import { useEffect, useState, useRef, useCallback } from 'react';
import { AxiosInstance } from 'axios';
import { useApi } from '../services/hooks/apiRedux';
import { useAuth } from '../store/auth';
import i18n from '../plugins/i18n/i18n';
import { errorToast, successToast } from '../utils/toasts';
import { InstancesServices } from '../services/InstancesServices';

type DirectorAndShareholderValues = {
  config_id: string | undefined;
  corporate_director_value: number;
  directors_value: number;
  shareholders_value: number;
};

export const useDirectorsAndShareholders = () => {
  const [values, setValues] = useState<DirectorAndShareholderValues | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const api: AxiosInstance = useApi();
  const { token } = useAuth();
  const initialLoadRef = useRef(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    console.log('chegou em diretor');
    
    try {
      if (!token) {
        errorToast(i18n.t('environment.userNotAuthenticated'));
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Language': i18n.language.toLowerCase()
        }
      };

      const response = await InstancesServices.getConfigs(api, config);
      console.log('response do director', response);

      setValues({
        config_id: response.config_id,
        directors_value: Number(response.directors_value),
        shareholders_value: Number(response.shareholders_value),
        corporate_director_value: Number(response.corporate_director_value)
      });

    } catch (error) {
      console.error('Error fetching directors/shareholders config:', error);
      errorToast(i18n.t('environment.errorFetchingDirectorsShareholdersConfig'));
    } finally {
      setLoading(false);
    }
  }, [api, token]);



  const updateConfigs = async (payload: DirectorAndShareholderValues) => {
    setLoading(true);
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Language': i18n.language.toLowerCase()
        }
      };

      await InstancesServices.updateConfig(api, payload, config);
      successToast(i18n.t('environment.feesUpdatedSuccess'));
      // await fetchData();
    } catch (error: any) {
      console.error('Erro ao atualizar taxa:', error);
      errorToast(error?.response?.data?.error?.[0] || i18n.t('environment.errorUpdatingFee'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Primeira carga - não precisa de delay
    if (initialLoadRef.current) {
      initialLoadRef.current = false;
      void fetchData();
      return;
    }

    // Quando o idioma mudar, espera um pouco antes de refazer a requisição
    const timeout = setTimeout(() => {
      void fetchData();
    }, 700);

    return () => {
      clearTimeout(timeout);
    };
  }, [fetchData, i18n.language]);

  return {
    values,
    loading,
    updateConfigs
  };
};
